import { Grid, Stack } from '@mui/material';

import { QuestionnaireSectionLabel } from '../../../../../common';
import { SelectionList } from '../../../../../../common';
import {
  EARLY_INTERVENTION_OPTIONS,
  PREGNANCY_ISSUE_OPTIONS,
  REGRESSION_OPTIONS,
} from '../constants';
import { getMedicalSelectionDeleteMessage } from '../utils';

import type { MedicalSelectionSectionsProps } from './types';

export default function MedicalSelectionSections({
  disabled,
  revealListErrors,
  earlyInterventions,
  pregnancyIssues,
  regressions,
  isSavingSelection,
  createSelection,
  deleteSelection,
}: MedicalSelectionSectionsProps) {
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Stack gap={2}>
            <QuestionnaireSectionLabel variant="h6">
              Early Childhood Intervention (ECI)
            </QuestionnaireSectionLabel>
            <SelectionList
              addButtonLabel="Add intervention"
              disabled={disabled}
              entries={earlyInterventions}
              error={!disabled && revealListErrors && earlyInterventions.length === 0}
              isSaving={isSavingSelection}
              getDeleteConfirm={(entry) => ({
                title: 'Confirm intervention deletion?',
                message: getMedicalSelectionDeleteMessage('intervention', entry),
              })}
              label="Early Childhood Intervention (ECI)"
              onAdd={(value) => createSelection('EARLY_INTERVENTION', value)}
              onDelete={(id) => deleteSelection('EARLY_INTERVENTION', id)}
              options={EARLY_INTERVENTION_OPTIONS}
              placeholder="Select intervention"
              required
            />
          </Stack>
        </Grid>
        <Grid item xs={12} md={6}>
          <Stack gap={2}>
            <QuestionnaireSectionLabel variant="h6">
              Issues during pregnancy or birth
            </QuestionnaireSectionLabel>
            <SelectionList
              addButtonLabel="Add issue"
              disabled={disabled}
              entries={pregnancyIssues}
              error={!disabled && revealListErrors && pregnancyIssues.length === 0}
              isSaving={isSavingSelection}
              getDeleteConfirm={(entry) => ({
                title: 'Confirm pregnancy issue deletion?',
                message: getMedicalSelectionDeleteMessage('pregnancy issue', entry),
              })}
              label="Issues during pregnancy or birth"
              onAdd={(value) => createSelection('PREGNANCY_ISSUE', value)}
              onDelete={(id) => deleteSelection('PREGNANCY_ISSUE', id)}
              options={PREGNANCY_ISSUE_OPTIONS}
              placeholder="Select issue"
              required
            />
          </Stack>
        </Grid>
      </Grid>

      <QuestionnaireSectionLabel variant="h6">
        Any regression in the areas of
      </QuestionnaireSectionLabel>
      <SelectionList
        addButtonLabel="Add regression"
        disabled={disabled}
        entries={regressions}
        error={!disabled && revealListErrors && regressions.length === 0}
        isSaving={isSavingSelection}
        getDeleteConfirm={(entry) => ({
          title: 'Confirm regression deletion?',
          message: getMedicalSelectionDeleteMessage('regression', entry),
        })}
        label="Any regression in the areas of"
        onAdd={(value) => createSelection('REGRESSION', value)}
        onDelete={(id) => deleteSelection('REGRESSION', id)}
        options={REGRESSION_OPTIONS}
        placeholder="Select regression"
        required
      />
    </>
  );
}
